new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

   waitForElementToExist('.widget-category').then(element => {
        if (window.innerWidth >= 992) {
            const container = document.querySelector('#widget-category');
            const items = Array.from(container.children);

            if (items.length < 8) {
                console.log('Slick não inicializado - menos de 8 itens em desktop:', items.length);
                return;
            }
        }

        $('#widget-category').slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 1000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 8,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#faixa-comunicado').then(element => {
        $('#faixa-comunicado').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            delay: 2000,
            autoPlaySpeed: 5000,
            speed: 100,
      
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
          });
    });

    waitForElementToExist('#carousel-comunicado').then(element => {
        if( $('#carousel-comunicado')) {
            $('#carousel-comunicado').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                delay: 2000,
                speed: 100,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('#product_list').then(element => {
        $('#product_list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });  
        $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });      
    });

    waitForElementToExist('#product_list2').then(element => {
        $('#product_list2').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });  
        $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });      
    });

    waitForElementToExist('#product_list3').then(element => {
        $('#product_list3').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });  
        $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });      
    });

    waitForElementToExist('#product_list4').then(element => {
        $('#product_list4').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });  
        $('#product_list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });      
    });


    waitForElementToExist('.widget-instagram__photos').then(element => {
        $('.widget-instagram__photos').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 5,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#widget-sustainability').then(element => {
        $('#widget-sustainability').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        })
    });

    waitForElementToExist('.product-ratings-list').then(element => {
        $('.product-ratings-list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        arrows: true,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        let rotationVitrine = document.querySelector('.rotation-vitrine');
        if (rotationVitrine) {
            let rotationNames = rotationVitrine.querySelectorAll('.categories .categories__name');
            let initVitrine = rotationVitrine.querySelectorAll('.rotation-vitrine__products .item');
            initVitrine = Array.from(initVitrine);
        
            if(rotationVitrine && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
        
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    $('#js-rotation-vitrine4, #js-rotation-vitrine3, #js-rotation-vitrine2, #js-rotation-vitrine').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        Blazy({
                            selector: '.lazy-img',
                            successClass: 'loaded-img',
                            success: function (element) {
                                setTimeout(function () {
                                    var parent = element.previousSibling;
                                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                }, 100);
                            }
                        });
                    });
                }
        
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }
        }

        $('#js-rotation-vitrine, #js-rotation-vitrine2, #js-rotation-vitrine3, #js-rotation-vitrine4').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 100,
    
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        })
    });
})